import type { Metadata } from 'next';
import './globals.css';
import { AuthProvider } from '@/context/AuthContext';
import { ThemeProvider } from '@/components/providers/ThemeProvider';
import Sidebar from '@/components/layout/Sidebar';
import Navbar from '@/components/layout/Navbar';
import MobileBottomNav from '@/components/layout/MobileBottomNav';

export const metadata: Metadata = {
  title: 'Credical | Loan Management App',
  description: 'Full-stack loan management system',
};

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="en" suppressHydrationWarning>
      <body suppressHydrationWarning className="antialiased min-h-screen flex flex-col md:flex-row bg-[var(--background)] text-[var(--foreground)]">
        <ThemeProvider>
          <AuthProvider>
            <Sidebar />
            <div className="flex-1 flex flex-col min-h-screen md:ml-64 w-full">
              <Navbar />
              <main className="flex-1 p-4 md:p-6 pb-24 md:pb-6 overflow-x-hidden">
                {children}
              </main>
            </div>
            <MobileBottomNav />
          </AuthProvider>
        </ThemeProvider>
      </body>
    </html>
  );
}
